import Breadcrumbs from "../../components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Button, Col, Container, FormGroup, Input, Label, Row, Spinner, Table } from "reactstrap"
import { withTranslation } from "react-i18next"
import { get } from "../../helpers/api_helper"
import Select from "react-select"

const Review = props => {
  const [reviews, setReviews] = useState([]);
  const [bags, setBags] = useState([]);
  const [selectedBag, setSelectedBag] = useState(null);
  const [selectedRating, setSelectedRating] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchReviews(selectedBag, currentPage);
  }, [currentPage]);

  useEffect(() => {
    fetchReviews(selectedBag, 1);
  }, [selectedBag, selectedRating]);

  useEffect(() => {
    fetchBags();
  }, [])

  const fetchBags = async () => {
    const responseBags = await get('bags');
    if (200 === responseBags.status && responseBags.data['hydra:member'].length > 0) {
      const newBags = responseBags.data['hydra:member'].map(item => ({
        label: item.name,
        value: item.id
      }));
      setBags([{ value: "all", label: "Tous" }, ...newBags]);
    }
  }

  const fetchReviews = async (bag, page) => {
    try {
      let params = { page };
      if (bag && 'all' !== bag.value) {
        params.bag = bag.value;
      }

      if ('' !== selectedRating) {
        params.rating = selectedRating;
      }
      setLoading(true);
      const response = await get('reviews', params);
      if (200 === response.status) {
        setReviews(response.data['hydra:member']);
        const view = response.data["hydra:view"];
        setNextPage(view?.["hydra:next"] ? page + 1 : null);
        setPrevPage(view?.["hydra:previous"] ? page - 1 : null);
      }
    } catch (error) {
      console.error("Erreur lors du chargement des avis :", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectBag = (selectedBag) => {
    setSelectedBag(selectedBag);
  }

  const handleFilterChange = (event) => {
    setSelectedRating(event.target.value);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Paniers - Avis")}
                       breadcrumbItem={props.t("Paniers - Avis")} />

          <Container fluid>

            {/* Filtre par notation */}
            <Row className="mb-3 justify-content-end">
              <Col md={4}>
                <FormGroup>
                  <Label>
                    Sélectionner un Panier :
                  </Label>
                  <Select
                    value={selectedBag}
                    onChange={e => {
                      handleSelectBag(e)
                    }}
                    options={bags}
                    className="select2-selection w-75"
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Filtrer par note :</Label>
                  <Input type="select" value={selectedRating} onChange={handleFilterChange}>
                    <option value="">Toutes les notes</option>
                    <option value="5">★★★★★ (5 étoiles)</option>
                    <option value="4">★★★★☆ (4 étoiles)</option>
                    <option value="3">★★★☆☆ (3 étoiles)</option>
                    <option value="2">★★☆☆☆ (2 étoiles)</option>
                    <option value="1">★☆☆☆☆ (1 étoile)</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            {loading ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
                <p>Chargement des commandes...</p>
              </div>
            ) : (
              <Table striped bordered hover responsive className="shadow-sm">
                <thead className="table-light">
                <tr>
                  <th>Panier</th>
                  <th>Note</th>
                  <th>Avis</th>
                  <th>Date</th>
                </tr>
                </thead>
                <tbody>
                {reviews.length > 0 ? (
                  reviews.map((review) => (
                    <tr key={review["@id"]}>
                      <td>{review.bag?.name || "Inconnu"}</td>
                      <td>
                        {[...Array(review.rating)].map((_, i) => (
                          <i key={i} className="mdi mdi-star text-warning font-size-14"></i>
                        ))}
                      </td>

                      <td>{review.comment || "Aucun commentaire"}</td>
                      <td>{new Date(review.createdAt).toLocaleDateString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center text-muted">Aucun avis disponible</td>
                  </tr>
                )}
                </tbody>
              </Table>
              )
            }
          </Container>
          <div className="d-flex justify-content-center my-3">
            <Button
              className="btn btn-sm mx-2"
              color="outline-primary"
              disabled={!prevPage}
              onClick={() => setCurrentPage(prevPage)}
            >
              ← Précédent
            </Button>
            <Button
              className="btn btn-sm"
              color="outline-primary"
              disabled={!nextPage}
              onClick={() => setCurrentPage(nextPage)}
            >
              Suivant →
            </Button>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(Review);
